import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SettingsService } from '@app/settings.service';
import { ButtonComponent } from '@app/shared/button/button.component';
import { PhoneStatusApiService } from '@modules/sign-in/components/initial/phone-status-api.service';
import { NgxMaskModule } from 'ngx-mask';
import { Subject, takeUntil } from 'rxjs';
import { TypeStep } from '../sign-up.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonComponent, NgxMaskModule],
})
export class LoginComponent implements OnInit {
  isSendPhone = false;
  currentLanguageAsKey = this._settingsService.getCurrentLanguageAsKey();
  destroy$: Subject<void> = new Subject<void>();
  @Input() form: FormGroup;
  @Output() changeStepStatus = new EventEmitter<TypeStep>();
  constructor(
    private _phoneStatusApiService: PhoneStatusApiService,
    private _settingsService: SettingsService,
  ) {}
  ngOnInit(): void {
  }

  fetchPhone() {
    // this.fetchPhoneEvent.emit('');
    this.isSendPhone = true;
    this._phoneStatusApiService
      .sendPhoneForLogin(this.form.get('login').value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.isSendPhone = false;
          this.changeStepStatus.emit('authorization');
        },
        ({ ...error }) => {
          this.isSendPhone = false;
          this.changeStepStatus.emit('code');
        },
      );
  }
}
